(() => {
function $5ceef45ebf251cff$var$initIntroAnimation() {
    const headingSpans = document.querySelectorAll(".section.hero-internal .heading-span");
    gsap.set(headingSpans, {
        opacity: 0
    });
    const els = SplitText.create(headingSpans, {
        type: "words",
        mask: "words",
        autoSplit: true,
        onSplit: (self)=>{
            gsap.set(headingSpans, {
                opacity: 1
            });
            gsap.set(self.words, {
                yPercent: 100
            });
        }
    });
    gsap.to(els.words, {
        yPercent: 0,
        stagger: 0.05,
        delay: 0.5,
        ease: "power4.out"
    });
}
document.fonts.ready.then(()=>{
    $5ceef45ebf251cff$var$initIntroAnimation();
});
// Function to initialize the count-up animation
function $5ceef45ebf251cff$var$initializeCountUpAnimations() {
    // Select all elements with the "count-number" tag
    const countElements = document.querySelectorAll("[count-number]");
    countElements.forEach((el)=>{
        // Get the number value from the element's text
        const targetText = el.textContent.trim();
        // Normalize the number by replacing commas with dots (if necessary) and parsing it
        const normalizedValue = parseFloat(targetText.replace(/,/g, ""));
        // Determine the number of decimal places
        const decimalPlaces = targetText.includes(".") ? targetText.split(".")[1].length : 0;
        // Skip if the value is not a valid number
        if (isNaN(normalizedValue)) return;
        // Create a GSAP ScrollTrigger animation
        gsap.set(el, {
            textContent: 0
        });
        gsap.to(el, {
            textContent: normalizedValue,
            scrollTrigger: {
                trigger: el,
                start: "top bottom",
                once: true
            },
            duration: 2,
            ease: "power2.out",
            snap: {
                textContent: Math.pow(10, -decimalPlaces)
            },
            onUpdate: function() {
                // Format the number dynamically during the animation
                el.textContent = parseFloat(el.textContent).toLocaleString(undefined, {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                });
            }
        });
    });
}
// Initialize the count-up animations when the page loads
document.addEventListener("DOMContentLoaded", ()=>{
    $5ceef45ebf251cff$var$initializeCountUpAnimations();
});

})();
//# sourceMappingURL=whyWebflow.js.map
